{
  "catalog": {
    "title": "Course catalogue",
    "subtitle": "Browse the courses published by teachers on the platform.",
    "searchLabel": "Search",
    "searchPlaceholder": "spanish conversation",
    "domain": "Domain",
    "allDomains": "All domains",
    "level": "Level",
    "allLevels": "All levels",
    "lessons": "Lessons",
    "lessonCount_one": "{{count}} lesson",
    "lessonCount_other": "{{count}} lessons",
    "empty": "No course matches this search.",
    "loadFailed": "The catalogue could not be loaded.",
    "rankedResults": "The {{shown}} most relevant courses, out of {{total}} matches.",
    "results": "Results",
    "suggestions": "Suggestions",
    "suggestionCount_one": "{{count}} suggestion",
    "suggestionCount_other": "{{count}} suggestions"
  },
  "levels": {
    "beginner": "Beginner",
    "intermediate": "Intermediate",
    "advanced": "Advanced"
  },
  "status": {
    "draft": "Draft",
    "published": "Published",
    "archived": "Archived"
  },
  "visibility": {
    "public": "Public — listed in the catalogue",
    "unlisted": "Unlisted — reachable by direct link",
    "private": "Private — visible to you only"
  },
  "blockers": {
    "title_too_short": "The title must be at least 3 characters long.",
    "description_too_short": "The description must be at least 50 characters long.",
    "no_published_lesson": "The course must contain at least one published lesson."
  },
  "course": {
    "about": "About this course",
    "curriculum": "Curriculum",
    "noLesson": "This course has no published lesson yet.",
    "read": "Read",
    "locked": "Restricted",
    "notFound": "This course cannot be found.",
    "lessonFailed": "This lesson could not be loaded.",
    "follow": "Follow this course"
  },
  "nav": {
    "myCourses": "Courses I teach"
  },
  "mine": {
    "title": "My courses",
    "subtitle": "Your courses, including drafts and archives.",
    "createTitle": "Create a course",
    "courseTitle": "Title",
    "chooseDomain": "Choose a domain",
    "create": "Create",
    "empty": "You have not created any course yet.",
    "loadFailed": "Your courses could not be loaded."
  },
  "editor": {
    "metadata": "Details",
    "subtitle": "Subtitle",
    "description": "Description",
    "descriptionHint": "At least 50 characters to be able to publish.",
    "noLevel": "Not specified",
    "visibility": "Visibility",
    "save": "Save",
    "saved": "Saved",
    "publish": "Publish",
    "unpublish": "Unpublish",
    "archive": "Archive",
    "delete": "Delete",
    "blockersTitle": "Something is still missing before publishing:",
    "curriculum": "Curriculum",
    "noLesson": "No lesson yet.",
    "newLesson": "New lesson title",
    "addLesson": "Add",
    "editLesson": "Edit",
    "removeLesson": "Delete lesson",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "addBlock": "Add a block",
    "removeBlock": "Remove block",
    "blockType": "Block type",
    "blockContent": "Block content",
    "headingLevel": "Heading level",
    "level": "Heading {{level}}",
    "textHint": "Write here…",
    "bulletHint": "One line per list item",
    "blocks": {
      "paragraph": "Paragraph",
      "heading": "Heading",
      "bulletList": "Bullet list",
      "blockquote": "Quote",
      "codeBlock": "Code block"
    },
    "upGlyph": "↑",
    "downGlyph": "↓",
    "removeGlyph": "✕"
  },
  "lesson": {
    "title": "Lesson title",
    "content": "Content",
    "publish": "Publish lesson",
    "unpublish": "Back to draft",
    "isPreview": "Readable without enrolling",
    "previewHint": "A preview lesson is readable by any visitor; the others require enrolling.",
    "backToCourse": "Back to course",
    "notFound": "This lesson cannot be found."
  },
  "resources": {
    "title": "Resources",
    "type": "Type",
    "label": "Label",
    "url": "Address",
    "video": "Video",
    "link": "Link",
    "pdf": "PDF document",
    "image": "Image",
    "download": "Download the document",
    "fileHint": "The file is uploaded then verified before being attached to the lesson.",
    "attach": "Attach",
    "remove": "Remove",
    "providersHint": "Accepted videos: YouTube, Vimeo, Dailymotion. Links must use https.",
    "file": "File"
  },
  "exercises": {
    "add": "Add an exercise",
    "addHint": "An exercise starts with just a title. The pass threshold, blocking and attempt limit are set afterwards, once the questions exist.",
    "titleLabel": "Exercise title",
    "isBlocking": "Blocking: the next lesson stays locked until this exercise is passed",
    "shuffle": "Shuffle questions and choices",
    "passingScore": "Pass threshold (%)",
    "maxAttempts": "Allowed attempts",
    "unlimited": "Unlimited",
    "gradingMode": "Grading",
    "maxScore": "Total score: {{total}} points",
    "questions": "Questions",
    "noQuestion": "No question yet.",
    "addQuestion": "Add the question",
    "questionType": "Question type",
    "prompt": "Prompt",
    "choices": "Choices",
    "choiceLabel": "Choice {{index}}",
    "markCorrect": "Correct answer",
    "addChoice": "Add a choice",
    "removeChoice": "Remove this choice",
    "answerKeys": "Accepted answers",
    "answerKeysHint": "Several spellings can be accepted for the same correct answer.",
    "answerKeyLabel": "Accepted answer {{index}}",
    "addAnswerKey": "Add an accepted answer",
    "removeAnswerKey": "Remove this answer",
    "explanation": "Explanation",
    "explanationHint": "Shown to the student after grading, never with the prompt.",
    "points": "{{points}} points",
    "correctAnswer": "correct answer",
    "moveUp": "Move the question up",
    "moveDown": "Move the question down",
    "removeQuestion": "Delete the question",
    "remove": "Delete the exercise",
    "preview": "Preview",
    "hidePreview": "Hide the preview",
    "previewTitle": "Student preview",
    "previewEmpty": "This exercise has no question yet.",
    "previewMeta": "Pass threshold: {{score}}% · total: {{total}} points",
    "previewAnswerPlaceholder": "Student answer",
    "blockingNotice": "unlocks the next lesson",
    "attemptsNotice_one": "{{count}} attempt",
    "attemptsNotice_other": "{{count}} attempts",
    "types": {
      "single_choice": "Single choice",
      "multiple_choice": "Multiple choice",
      "true_false": "True or false",
      "short_text": "Short answer",
      "number": "Number",
      "open_text": "Free text (manually graded)",
      "file_upload": "File upload (manually graded)"
    },
    "gradingModes": {
      "auto": "automatic",
      "manual": "manual",
      "mixed": "mixed"
    },
    "reasons": {
      "blocking_exercise_without_question": "A blocking exercise must have at least one question.",
      "question_without_prompt": "A question must have a prompt.",
      "question_needs_two_choices": "A choice question needs at least two choices.",
      "single_choice_needs_exactly_one_correct": "A single-choice question must have exactly one correct answer.",
      "multiple_choice_needs_a_correct_choice": "A multiple-choice question must have at least one correct answer.",
      "true_false_needs_two_choices": "A true/false question must have exactly two choices.",
      "question_without_answer_key": "A free-answer question needs at least one accepted answer."
    },
    "editQuestion": "Edit the question",
    "instructions": "Instructions",
    "instructionsHint": "Shown to the student before they start the exercise."
  }
}
